// @ts-ignore
export const isServer = !process.browser
